import request from '@/utils/request'

// 查询知识产权超市列表
export function listMarket(query) {
  return request({
    url: '/web/market/list',
    method: 'get',
    params: query
  })
}

export function listOrderByDescTwo(query) {
  return request({
    url: '/web/market/listOrderByDescTwo',
    method: 'get',
    params: query
  })
}

// 查询知识产权超市详细
export function getMarket(recid) {
  return request({
    url: '/web/market/' + recid,
    method: 'get'
  })
}

/*export function listOrderByDescTwo(detail) {
  return request({
    url: '/web/market/listOrderByDescTwo',
    method: 'get',
    params: detail
  })
}*/

// 新增知识产权超市
export function addMarket(data) {
  return request({
    url: '/web/market',
    method: 'post',
    data: data
  })
}

// 修改知识产权超市
export function updateMarket(data) {
  return request({
    url: '/web/market/edit',

    method: 'post',
    data: data
  })
}

// 删除知识产权超市
export function delMarket(recid) {
  return request({
    url: '/web/market/remove/' + recid,

    method: 'post',
  })
}

// 导出知识产权超市
export function exportMarket(query) {
  return request({
    url: '/web/market/export',
    method: 'get',
    params: query
  })
}